module.exports = __webpack_public_path__ + "81d7a7d2730dcad7b6e0b00f2d23d8a5.pdf";